import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/lib/utils";

type TabsBrandingProps = {
  colorPrimario?: string;
  colorSecundario?: string;
  tipografiaMarca?: string;
} & React.ComponentProps<typeof TabsPrimitive.Root>;

function Tabs({
  className,
  colorPrimario = "#1e293b",
  colorSecundario = "#64748b",
  ...props
}: TabsBrandingProps) {
  // Pasa los colores como variables CSS para el gradiente dinámico
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      style={
        {
          // Permite override dinámico de los colores de marca
          "--colorPrimario": colorPrimario,
          "--colorSecundario": colorSecundario,
        } as React.CSSProperties
      }
      className={cn(
        "bg-[var(--background)] mx-auto w-full max-w-screen-xl md:max-w-[83.333%] rounded-xl shadow-md overflow-hidden border",
        className
      )}
      {...props}
    />
  );
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "text-muted-foreground flex h-15 w-full items-center justify-center border-b",
        className
      )}
      {...props}
    />
  );
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "data-[state=active]:bg-[var(--background)] data-[state=active]:border-[var(--colorPrimario)] dark:data-[state=active]:text-[var(--foreground)] focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 text-foreground dark:text-muted-foreground inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 border-b-4 border-transparent px-4 py-1 text-sm font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-lg [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        className
      )}
      {...props}
    />
  );
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn("flex-1 outline-none", className)}
      {...props}
    />
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
